<template>
    <div id="templates">
        <lutPreviews />
        <blocksControls />

        <blackAndWhite />
        <lut />
        <Contrast />
        <ContrastV2 />
        <curve />
        <customLut />
        <CustomLutV2 />
        <Exposure />
        <ExposureV2 />
        <HSL />
        <SkinToneEditor />
        <hueSaturation />
        <logPrimaries />
        <magicMode />
        <Primaries />
        <PrimariesV2 />
        <PrinterLights />
        <PrinterLightsV2 />
        <shadowHighlightsRecovery />
        <smartWarmth />
        <Technicolor3StripProcess />
        <tealAndOrange />
        <whiteBalance />
        <MidtoneTexture />
        <ColourDensity />
        <SubtractiveColour />
        <ColourMatch />
        <ColourMatchV2 />
        <AdvancedColourMatchV2 />
        <AIColourExtract />
        <AIColourExtractV2 />
        <AIAutoCorrect />
        <AIAutoCorrectV2 />
        <NeuralToneAI />
        <NeuralFilmAI />
        <AIColourMatch />
        <AIColourMatchV2 />
        <LMT />
        <GamutCompress />
        <AIMagicMode />
        <AIExposure />
        <AIContrast />
        <AIWhiteBalance />
        <Vibrance />
<!--        <LensDistortionEffect />-->
        <TetrahedralInterpolation />
    </div>
</template>

<script>
import lutPreviews from "@/views/templates/lutPreviews";
import blocksControls from "@/views/templates/blocks/includes/controls";

import lut from "@/views/templates/blocks/lut";
import blackAndWhite from "@/views/templates/blocks/blackAndWhite";
import Contrast from "@/views/templates/blocks/Contrast";
import ContrastV2 from "@/views/templates/blocks/ContrastV2";
import curve from "@/views/templates/blocks/curve";
import customLut from "@/views/templates/blocks/customLut";
import CustomLutV2 from "@/views/templates/blocks/CustomLutV2";
import Exposure from "@/views/templates/blocks/Exposure";
import ExposureV2 from "@/views/templates/blocks/ExposureV2";
import HSL from "@/views/templates/blocks/HSL";
import SkinToneEditor from "@/views/templates/blocks/SkinToneEditor";
import hueSaturation from "@/views/templates/blocks/hueSaturation";
import logPrimaries from "@/views/templates/blocks/logPrimaries";
import magicMode from "@/views/templates/blocks/magicMode";
import Primaries from "@/views/templates/blocks/Primaries";
import PrimariesV2 from "@/views/templates/blocks/PrimariesV2";
import PrinterLights from "@/views/templates/blocks/PrinterLights";
import PrinterLightsV2 from "@/views/templates/blocks/PrinterLightsV2";
import shadowHighlightsRecovery from "@/views/templates/blocks/shadowHighlightsRecovery";
import smartWarmth from "@/views/templates/blocks/smartWarmth";
import Technicolor3StripProcess from "@/views/templates/blocks/Technicolor3StripProcess";
import tealAndOrange from "@/views/templates/blocks/tealAndOrange";
import whiteBalance from "@/views/templates/blocks/whiteBalance";
import MidtoneTexture from "@/views/templates/blocks/MidtoneTexture";
import ColourDensity from "@/views/templates/blocks/ColourDensity";
import SubtractiveColour from "@/views/templates/blocks/SubtractiveColour";
import ColourMatch from "@/components/app/blocks/ColourMatch/V1/ColourMatchTemplate.vue";
import ColourMatchV2 from "@/components/app/blocks/ColourMatch/V2/ColourMatchV2Template.vue";
import AdvancedColourMatchV2 from "@/components/app/blocks/ColourMatch/V2/AdvancedColourMatchV2Template.vue";
import LMT from "@/components/app/blocks/LMT/Template";
import AIColourExtract from "@/components/app/blocks/AIColourExtract/V1/AIColourExtractTemplate";
import AIColourExtractV2 from "@/components/app/blocks/AIColourExtract/V2/AIColourExtractTemplate";
import AIAutoCorrect from "@/views/templates/blocks/AIAutoCorrect";
import AIAutoCorrectV2 from "@/views/templates/blocks/AIAutoCorrectV2";
import NeuralToneAI from "@/views/templates/blocks/NeuralToneAI.vue";
import NeuralFilmAI from "@/views/templates/blocks/NeuralFilmAI.vue";
import AIColourMatch from "@/components/app/blocks/AIColourMatch/V1/AIColourMatchTemplate.vue";
import AIColourMatchV2 from "@/components/app/blocks/AIColourMatch/V2/AIColourMatchV2Template.vue";
import GamutCompress from "@/views/templates/blocks/GamutCompress";
import AIMagicMode from "@/views/templates/blocks/AIMagicMode.vue";
import AIExposure from "@/views/templates/blocks/AIExposure.vue";
import AIContrast from "@/views/templates/blocks/AIContrast.vue";
import AIWhiteBalance from "@/views/templates/blocks/AIWhiteBalance.vue";
import Vibrance from "@/views/templates/blocks/Vibrance.vue";
// import LensDistortionEffect from "@/views/templates/blocks/LensDistortionEffect";
import TetrahedralInterpolation from "@/views/templates/blocks/TetrahedralInterpolation";

export default {
    name: "Templates",
    components: {
        Vibrance,
        AIWhiteBalance,
        AIContrast,
        AIExposure,
        AIMagicMode,
        lutPreviews,
        blocksControls,

        lut,
        blackAndWhite,
        Contrast,
        ContrastV2,
        curve,
        customLut,
        CustomLutV2,
        Exposure,
        ExposureV2,
        HSL,
        SkinToneEditor,
        hueSaturation,
        logPrimaries,
        magicMode,
        Primaries,
        PrimariesV2,
        PrinterLights,
        PrinterLightsV2,
        shadowHighlightsRecovery,
        smartWarmth,
        Technicolor3StripProcess,
        tealAndOrange,
        whiteBalance,
        MidtoneTexture,
        ColourDensity,
        SubtractiveColour,
        ColourMatch,
        ColourMatchV2,
        AdvancedColourMatchV2,
        AIColourExtract,
        AIColourExtractV2,
        AIAutoCorrect,
        AIAutoCorrectV2,
        NeuralToneAI,
        NeuralFilmAI,
        AIColourMatch,
        AIColourMatchV2,
        LMT,
        GamutCompress,
        // LensDistortionEffect,
        TetrahedralInterpolation
    }
}
</script>